module.exports = __webpack_public_path__ + "img/phone.a4550c1c.png";